module.exports = __webpack_public_path__ + "img/universitaet-greifswald.b85e7149.png";